function ArrowCircleRight() {
  return (
    <svg
      width="62"
      height="62"
      viewBox="0 0 62 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="31" cy="31" r="30.5" stroke="#0050AE" />
      <path
        d="M22.25 31H39.75M39.75 31L31 22.25M39.75 31L31 39.75"
        stroke="#0050AE"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ArrowCircleRight;
